import Vue from "vue";
import { abilitiesPlugin, Can } from "@casl/vue";
import { buildAbilityFor } from "@/services/auth/ability";
import { User } from "@/entities";

const ability = buildAbilityFor({} as User);

Vue.use(abilitiesPlugin, ability);

Vue.component("Can", Can);
